import { Component, OnInit } from '@angular/core';
import { faPencilAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { QuestionnariesService } from 'src/app/shared/services/questionnaries.service'
import { Questionnarie } from '../shared/models/questionnarie.model';
import { Filter } from '../shared/models/filter.model';
import { Observable, Subscription } from 'rxjs';
import { QuestionnarieGroupService } from '../shared/services/questionnaries-group.service';
import { Lookup } from '../shared/models/admin-models/lookup.model';
import { RoleSendService } from '../shared/services/role-send.service';

@Component({
  selector: 'app-questionnaires',
  templateUrl: './questionnaires.component.html',
  styleUrls: ['./questionnaires.component.sass']
})
export class QuestionnairesComponent implements OnInit {
  faSearch = faSearch
  faPencilAlt = faPencilAlt
  faTrashAlt = faTrashAlt

  addOrEditBool: Boolean;
  filter: Filter = new Filter({ Top: 10, Page: 1, Filter: {}, Sort: {} })
  questionnaries: Array<any>
  groups: Observable<Lookup[]>
  total: number = 0

  questionnarieId: Number;
  roleService: Subscription;
  roleType: String;

  questionForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    webName: new FormControl('', [Validators.required]),
    group: new FormControl('', [Validators.required])
  })

  filterForm = new FormGroup({
    group: new FormControl('')
  })

  constructor(private modalService: NgbModal, private questionnarieService: QuestionnariesService, private questionnarieGroupService: QuestionnarieGroupService, private roleSendService: RoleSendService) {
    this.roleService = this.roleSendService.info$.subscribe(
      (res: String) => {
        this.roleType = res;
      }
    )
  }

  ngOnInit() {
    this.getAll()
    this.getAllGroup()
  }

  getAll() {
    this.filter.data.Filter = {}
    if (this.filterForm.value.group)
      this.filter.data.Filter.GroupID = this.filterForm.value.group;
    this.questionnarieService.gridView(this.filter)
      .subscribe(
        x => {
          this.questionnaries = x.data
          this.total = x.total
        },
        e => console.log(e)
      )
  }

  openAddModal(modal) {
    this.addOrEditBool = true
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  addQuestionnarie() {
    if (this.questionForm.valid) {
      this.questionnarieService.createQuestionnarie(new Questionnarie({ ID: 0, GroupID: this.questionForm.value.group, Caption: this.questionForm.value.webName, Filename: this.questionForm.value.name }))
        .then(
          x => {
            this.getAll()
            this.modalService.dismissAll()
          }
        )
    }
  }

  openEditModal(modal, id) {
    this.addOrEditBool = false
    this.questionnarieId = id
    this.questionnarieService.getOne(id)
      .then(
        (x: { caption: String, filename: String, groupID: Number }) => {
          this.questionForm.get('webName').setValue(x.caption);
          this.questionForm.get('name').setValue(x.filename);
          this.questionForm.get('group').setValue(x.groupID);
          this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
        }
      )
  }
  editQuestionnarie() {
    if (this.questionForm.valid) {
      this.questionnarieService.editQuestionnarie(new Questionnarie({ ID: this.questionnarieId, GroupID: this.questionForm.value.group, Caption: this.questionForm.value.webName, Filename: this.questionForm.value.name }))
        .then(
          x => {
            this.getAll()
            this.modalService.dismissAll()
          }
        )
    }
  }

  openDeleteModal(modal, id) {
    this.questionnarieId = id
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  deleteQuestionnarie() {
    this.questionnarieService.deleteQuestionnarie([this.questionnarieId])
      .then(
        x => {
          this.getAll()
          this.modalService.dismissAll()
        }
      )
  }

  getAllGroup() {
    this.groups = this.questionnarieGroupService.boxView();
  }

  clearFilters() {
    this.filterForm.reset({ group: '' })
    this.getAll()
  }

}
